import { ChangeEventHandler } from 'react';

import { PriceInput } from '@/components/PrettyNumbers/Filters/PriceInputs/PriceInput/PriceInput.tsx';
import { useFilterStore } from '@/store';
import { convertPrice } from '@/utils';

import cn from './styles.module.sass';

interface IPriceInputsProps {
    priceMin: string;
    priceMax: string;
}

export const PriceInputs = ({ priceMax, priceMin }: IPriceInputsProps) => {
    const { setPriceMin, setPriceMax, setSearchParams } = useFilterStore();

    const handleMinPriceChange: ChangeEventHandler<HTMLInputElement> = e => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
        setPriceMin(sanitizedValue);
        setSearchParams({ priceMin: sanitizedValue });
    };

    const handleMaxPriceChange: ChangeEventHandler<HTMLInputElement> = e => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
        setPriceMax(sanitizedValue);
        setSearchParams({ priceMax: sanitizedValue });
    };

    const formattedPriceMin = convertPrice(priceMin);
    const formattedPriceMax = convertPrice(priceMax);

    return (
        <div className={cn.priceInputsContainer}>
            <PriceInput
                value={formattedPriceMin}
                onChange={handleMinPriceChange}
                type="tel"
                placeholder="От 0 руб."
            />
            <PriceInput
                value={formattedPriceMax}
                onChange={handleMaxPriceChange}
                type="tel"
                placeholder="До ∞ руб."
            />
        </div>
    );
};
